export default __webpack_public_path__ + "static/media/check_circle_dark.0e87b833.svg";